import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Seo from '../shared/Seo';

const TERMS_SECTIONS = [
  {
    title: '1. Agreement to Terms',
    body:
      'By purchasing from PonPon, you confirm that you are at least the age of majority in your state of residence in the United States.',
  },
  {
    title: '2. About Us',
    body: 'PonPon Interactive LLC is a company operated and based in the United States.',
  },
  {
    title: '3. The Locker System',
    bullets: [
      'Overview: PonPon offers a digital "Locker" system to registered members. The Locker system allows you to temporarily store your physical capsule toys after each spin. The actual item is safely held in our warehouse and displayed virtually in your Locker. Each Locker includes storage for up to eight (8) items.',
      'Storage and Shipping: After each spin, your prize will automatically be stored in your Locker. By using the Locker system, you authorize us to hold the physical items in our warehouse for a limited period. Free standard shipping is provided only when you request shipment of a full Locker (8 items). Shipping a partial Locker (fewer than 8 items) is available and subject to shipping fees. You may also purchase additional Locker capacity, which increases your free-shipping threshold.',
      'Showcase Feature: The Locker System includes a digital showcase, allowing you to display your collection. You are responsible for maintaining the confidentiality of your showcase link if you wish to keep it private.',
      'Locker Limits: Each account includes one (1) Locker with a default capacity of eight (8) items. You may purchase additional storage slots to expand your Locker’s capacity. Only one active Locker is allowed per account.',
      'Ownership & Risk: Title to the physical products stored in your Locker transfers to you upon purchase. While your items remain stored in our facility, PonPon retains responsibility for loss or damage. Once your Locker is shipped, our standard shipping terms apply, and risk of loss transfers to you.',
      'Inactivity: We reserve the right to ship the items in a Locker that has been inactive (no new items added or shipped) for a period of 12 months to the address on file.',
      'Modification & Discontinuation: PonPon reserves the right to update, modify, or discontinue the Locker System. We will provide reasonable notice before making significant changes or discontinuing the service.',
    ],
  },
  {
    title: '4. Products and Capsule Toys Nature',
    bullets: [
      'Reseller Status: PonPon operates as a reseller of collectible capsule toys. We are not the manufacturer or licensor of these products.',
      'Randomness: All capsule toy sales are final. Customers understand and accept that the specific style of the collectible toy received is random and not guaranteed. We do not accommodate requests for particular variations or common styles.',
      'Probabilities: The stated probabilities for “Secret” or “Rare” items are determined by the original manufacturer. PonPon does not guarantee that any individual customer will receive a rare item within a specific number of purchases.',
      'Product Information: We strive to display accurate colors, images, and descriptions of our products; however, minor variations may occur due to differences in display settings or manufacturing batches.',
      'Availability: We reserve the right to limit the sales of our products to any person, geographic region, or jurisdiction within the United States. All product descriptions and pricing are subject to change at any time without notice.',
    ],
  },
  {
    title: '5. Orders and Payment',
    bullets: [
      'Order Acceptance: We reserve the right to refuse any order you place with us. At our sole discretion, we may limit or cancel quantities purchased per person, per household, or per order.',
      'Pricing: All token price listings are subject to change without notice. PonPon is not responsible for typographical errors regarding pricing.',
      'Payment: You agree to provide current, complete, and accurate purchase and account information for all purchases made at our store. All payments are processed through our authorized payment providers. Tokens are non-refundable once purchased and may only be used within the PonPon platform to initiate spins or other eligible activities.',
    ],
  },
  {
    title: '6. Shipping and Delivery',
    bullets: [
      'Processing Time: Orders designated for immediate shipping are processed within 1-2 business days. Please allow another 2-5 business days for shipment to be delivered. PonPon is an online-only retailer. Shipping times are estimates and are not guaranteed.',
      'Locker Shipments: Shipments for full Lockers will be processed within 2-4 business days of your shipment request.',
      'Shipping Risk: Title and risk of loss for all shipped items transfer to you once we deliver the package to the carrier.',
      'Lost/Stolen Packages: PonPon is not responsible for packages that are lost, stolen, or damaged after being marked as "Delivered" by the shipping carrier. Customers are responsible for filing a claim directly with the shipping carrier. For packages lost in transit before delivery, we will review the case and assist at our discretion.',
    ],
  },
  {
    title: '7. Return, Refund, and Damage Policy',
    bullets: [
      {
        text:
          'All Sales Are Final: Due to the random, collectible nature of capsules, PonPon does not offer returns, exchanges, or refunds for:',
        subItems: ['Receiving an unwanted common style.', 'Receiving duplicate items.', '"Change of mind."'],
      },
      'Refunds for Defective Items Only: Refunds are available only for products with verifiable manufacturing defects. If you believe you have received a defective item, please contact our Customer Service team at salesponpon@gmail.com within 7 days of the item’s delivery. You will be required to provide your order number and clear photo or video evidence of the defect, along with the original packaging. Each case will be reviewed individually, and, at our discretion, we may offer a replacement (if available) or a refund. We may require the defective item to be returned to us.',
      'Incorrect Items Shipped: If you receive an item from a completely different series than what you ordered, please contact us within 7 days with evidence. We will arrange for the correct shipment upon return of the incorrect item.',
    ],
  },
  {
    title: '8. Intellectual Property (Important Notice)',
    body:
      'PonPon is a reseller and does not own the intellectual property (including designs, characters, or logos) of the collectible toys sold on this site. All such intellectual property belongs to its respective manufacturers and licensors. The use of any such property without the express permission of the rightful owner is strictly prohibited.\n\nResale of Physical Goods (First Sale Doctrine): The sale of the physical capsule toys by PonPon is conducted under the First Sale Doctrine (17 U.S.C. § 109). This doctrine allows for the resale of a legally purchased item without permission from the copyright holder.\nThis applies only to the specific physical item you purchase. It does not grant you, as the end customer, any right or license to reproduce, distribute, publicly display, or create derivative works based on the copyrighted characters or designs. You own the physical toy, but not the intellectual property it represents.',
  },
  {
    title: '9. User Comments and Submissions',
    body:
      'Any creative ideas, suggestions, or materials you send to us (Submissions) may be used by PonPon without restriction or compensation. By providing Submissions, you confirm you have the right to share them and that they do not violate anyone else’s rights.',
  },
  {
    title: '10. Prohibited Uses',
    body:
      'You are prohibited from using the site or its content for any unlawful purpose, to solicit others to perform unlawful acts, or to harass, abuse, or harm others. You also may not interfere with the site’s security or operation.',
  },
  {
    title: '11. Limitation of Liability',
    body:
      'PonPon is not liable for any indirect, incidental, special, or consequential damages arising out of your use or inability to use our products or services. Our total liability for any claim is limited to the amount you paid for the product(s) at issue.',
  },
  {
    title: '12. Governing Law',
    body:
      'These Terms of Service are governed by the laws of the United States and the State of California, without regard to its conflict-of-law provisions.',
  },
  {
    title: '13. Changes to Terms',
    body:
      'We reserve the right to update, change, or replace any part of these Terms of Service by posting updates and changes to our website. The updated version is effective when posted. It is your responsibility to check our website periodically for any updates or changes.',
  },
  {
    title: '14. Contact Information',
    body: 'Questions about the Terms of Service should be sent to us at: salesponpon@gmail.com.',
  },
];

const TermsPage = () => {
  useEffect(() => {
    const smoothScroll = () => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    const ensureTop = () => {
      const doc = document?.documentElement;
      const body = document?.body;
      const current = (doc?.scrollTop || 0) + (body?.scrollTop || 0);
      if (current > 0) {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      }
    };

    smoothScroll();
    const retryId = window.setTimeout(ensureTop, 220);
    const fallbackId = window.setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }, 900);

    return () => {
      window.clearTimeout(retryId);
      window.clearTimeout(fallbackId);
    };
  }, []);

  const renderBulletContent = (item, key) => {
    if (typeof item === 'string') {
      return <span className="whitespace-pre-line">{item}</span>;
    }

    if (item && typeof item === 'object') {
      const { text, subItems } = item;
      return (
        <>
          {text ? <span className="whitespace-pre-line">{text}</span> : null}
          {Array.isArray(subItems) && subItems.length ? (
            <ul className="mt-2 list-disc space-y-1 pl-5 text-sm leading-relaxed text-ponpon-navy/75">
              {subItems.map((subItem, subIndex) => (
                <li key={`${key}-sub-${subIndex}`} className="whitespace-pre-line">
                  {subItem}
                </li>
              ))}
            </ul>
          ) : null}
        </>
      );
    }

    return null;
  };

  const renderSectionBody = (body) => {
    if (typeof body === 'string') {
      return <p className="whitespace-pre-line text-sm leading-relaxed text-ponpon-navy/75">{body}</p>;
    }

    if (React.isValidElement(body)) {
      return (
        <div className="text-sm leading-relaxed text-ponpon-navy/75">
          {body}
        </div>
      );
    }

    return null;
  };

  return (
    <div className="flex flex-col gap-8">
      <Seo
        title="Terms of Service | PonPon!"
        description="Read the PonPon! Terms of Service for Locker guidelines, shipping rules, refund policy, and intellectual property notices."
        canonical="https://ponpon.app/terms"
        type="article"
      />
      <header>
        <h1 className="font-display text-3xl font-semibold text-ponpon-navy sm:text-4xl">
          Terms of Service
        </h1>
        <p className="mt-2 text-xs uppercase tracking-wide text-ponpon-navy/60">
          Last Update: November, 2025
        </p>
        <div className="mt-4 space-y-3 text-sm leading-relaxed text-ponpon-navy/75">
          <p>Welcome to PonPon!</p>
          <p className="text-sm font-semibold leading-relaxed text-ponpon-navy">
            PLEASE READ THESE TERMS OF SERVICE CAREFULLY BEFORE USING THIS WEBSITE OR PURCHASING ANY
            PRODUCTS.
          </p>
          <p>
            By accessing this site or making a purchase, you agree to comply with and be bound by
            these Terms of Service.
          </p>
        </div>
      </header>

      <div className="space-y-6">
        {TERMS_SECTIONS.map(({ title, body, bullets }) => (
          <div key={title} className="space-y-2">
            <h2 className="text-base font-semibold text-ponpon-navy sm:text-lg">{title}</h2>
            {body ? renderSectionBody(body) : null}
            {Array.isArray(bullets) ? (
              <ul className="list-disc space-y-2 pl-5 text-sm leading-relaxed text-ponpon-navy/75">
                {bullets.map((item, index) => (
                  <li key={`${title}-${index}`}>{renderBulletContent(item, `${title}-${index}`)}</li>
                ))}
              </ul>
            ) : null}
          </div>
        ))}
      </div>

      <div className="mt-4 flex justify-end">
        <Link
          to="/"
          className="inline-flex items-center gap-2 rounded-full bg-ponpon-coral px-6 py-2.5 text-sm font-semibold text-white shadow-[0_12px_26px_rgba(226,58,50,0.28)] transition hover:-translate-y-0.5 hover:bg-[#E23A32] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ponpon-coral/60"
        >
          <span aria-hidden="true">←</span>
          Back to homepage
        </Link>
      </div>
    </div>
  );
};

export default TermsPage;
